import React from 'react';
import {DateRow, NameRow, PriceRow, TextRow, TextToolTip} from 'components';
import {Images} from 'assets/images';
import {ReactComponent as ProblemSolvingSvg} from "../../../assets/images/svg/ProblemSolvingSvg.svg";
import {operationTypesEnum} from "../../../fragments";

const renderButtons = (data, info, load) => {
    return <div className="del-edit-wrapper">
        <button onClick={() => data('edit')}>
            <img src={Images.Edit} alt={'icon'}/>
            <p className="edit-text">Edit</p>
        </button>
        <button onClick={() => data('delete')}>
            <img src={Images.Remove} alt={'icon'}/>
            <p className="delete-text">Delete</p>
        </button>
    </div>;
};

export const shopifyHead = [
    {name: '', notSearch: true, custom: false, maxWidth: 60, cellWidth: 60},
    {name: 'searchRequest', nameRow: 'sku', title: 'Shopify SKU', custom: false},
    // { name: 'sku', title: 'Shopify SKU' },
    {name: 'productType', title: 'Type', custom: false},
    {name: 'actions', title: 'Actions', custom: false, type: 'notChange'},
];

export const shopifyBody = [
    // { rowText: (item) => <NameRow name={item?.sku} />, notClickable: true },
    // { rowText: (item) => <TextRow  big={true} size={20} name={'item?.erplyCode'} />, notClickable: true },
    // { rowText: (item) => <NameRow name={item?.multiplier} />, notClickable: true },
    // { rowText: (item) => <NameRow name={item?.productType ? item?.productType : 'Not Set'} />, notClickable: true },
    // { button: (item, info, load) => renderButtons(item, info, load), notClickable: true },
];


export const shopifyOrderHead = [
    {name: 'searchRequest', nameRow: 'orderId', title: ' Shopify Order ID', custom: false},
    {name: 'addedDate', title: 'Added Date,Time', custom: false},
    {name: 'createdAt', title: 'Created Date', custom: false},
    {name: 'Status', title: 'Status', custom: false},
    {name: 'actions', title: 'Actions', custom: false, type: 'notChange'},
];

export const shopifyOrderBody = [
    {rowText: (item) => <NameRow name={item?.sku}/>, notClickable: true},
    {rowText: (item) => <NameRow big={true} size={20} name={item?.erplyCode}/>, notClickable: true},
    {rowText: (item) => <NameRow name={item?.multiplier}/>, notClickable: true},
    {rowText: (item) => <NameRow name={item?.productType ? item?.productType : 'Not Set'}/>, notClickable: true},
    {button: (item, info, load) => renderButtons(item, info, load), notClickable: true},
];


export const shopifyInventoryTransferHead = (operationType) => {
    if (operationType === operationTypesEnum.TRANSFER) {
        return [
            {name: 'transferId', title: 'ID', custom: false},
            {name: 'transferDate', title: 'Date', custom: false},
            {name: 'warehouseFrom', title: 'Warehouse From', custom: false},
            {name: 'warehouseTo', title: 'Warehouse To', custom: false},
            {name: 'qty', title: 'Qty', custom: false},
            {name: 'status', title: 'Status', custom: false, type: 'notChange'},
        ]
    } else {
        return [
            {name: 'transferId', title: 'ID', custom: false},
            {name: 'transferDate', title: 'Date', custom: false},
            {name: 'warehouse', title: 'Warehouse', custom: false},
            {name: 'qty', title: 'Qty', custom: false},
            {name: 'status', title: 'Status', custom: false, type: 'notChange'},
        ]
    }
};

export const shopifyInventoryTransferBody = (operationType) => {
    if (operationType === operationTypesEnum.TRANSFER) {
        return [
            {rowText: (item) => <NameRow name={item?.sku}/>, notClickable: true},
            {rowText: (item) => <NameRow big={true} size={20} name={item?.erplyCode}/>, notClickable: true},
            {rowText: (item) => <NameRow name={item?.multiplier}/>, notClickable: true},
            {
                rowText: (item) => <NameRow name={item?.productType ? item?.productType : 'Not Set'}/>,
                notClickable: true
            },
            {button: (item, info, load) => renderButtons(item, info, load), notClickable: true},
        ]
    } else {
        return [
            {rowText: (item) => <NameRow name={item?.sku}/>, notClickable: true},
            {rowText: (item) => <NameRow big={true} size={20} name={item?.erplyCode}/>, notClickable: true},
            {
                rowText: (item) => <NameRow name={item?.warehouse ? item?.warehouse : 'Not Set'}/>,
                notClickable: true
            },
            {button: (item, info, load) => renderButtons(item, info, load), notClickable: true},
        ]
    }
};


export const shopifyErrorsHead = [
    {name: 'store', title: ' Store Name', type: 'date', custom: false, headerCellWidth: '15%'},
    {name: 'createdAt', title: ' Date', type: 'date', custom: false, headerCellWidth: '15%'},
    {name: 'message', title: 'Message', custom: false, headerCellWidth: '55%'},
    {name: 'actions', title: 'Actions', custom: false, type: 'notChange', headerCellWidth: '15%'},
];

export const shopifyErrorsBody = (onClick, currentId) => {
    return [
        {
            rowText: (item) => {
                return <TextToolTip text={item?.storeSetup?.name} content={item?.storeSetup?.name}/>
            },
            width: '15%'
        },

        {rowText: (item) => <DateRow date={item?.createdAt}/>, width: '15%'},
        {
            rowText: (item) => <TextToolTip text={item?.message} content={item?.message}/>,
            notClickable: true,
            width: '55%'
        },
        {
            button: (item, info, load) => (
                <div style={{display: 'flex', alignItems: 'center', gap: '8px', width: '15%'}}
                     onClick={() => onClick(info)}>
                    <ProblemSolvingSvg/>
                    <p style={{
                        fontSize: '14',
                        fontWeight: '600',
                        textDecoration: 'underline',
                        color: '#BA43B1'
                    }}>
                        {currentId === info.id ? 'Resolving...' : 'Resolve'}
                    </p>
                </div>
            ),
        }
    ]
}


export const shopifyPriceErrorsHead = [
    {name: 'store', title: ' Store Name', type: 'date', custom: false, headerCellWidth: '15%'},
    {name: 'createdAt', title: 'Date', type: 'date', custom: true, headerCellWidth: '15%'},
    {name: 'sku', title: 'SKU', custom: false, headerCellWidth: '15%'},
    {name: 'price', title: 'Price', custom: false, headerCellWidth: '15%'},
    {name: 'message', title: 'Message', custom: false, headerCellWidth: '40%'},
];

export const shopifyPriceErrorsBody = [
    {rowText: (item) => <TextToolTip text={item?.shopifySetup?.name} content={item?.shopifySetup?.name}/>},
    {rowText: (item) => <DateRow date={item?.createdAt}/>},
    {rowText: (item) => <TextRow name={item?.sku}/>},
    {rowText: (item) => <PriceRow info={item?.price}/>},
    {
        rowText: (item) => <TextToolTip text={item?.message} content={item?.message}/>,
        notClickable: true,
        width: '40%',
    },
];

export const shopifyStoresStatus = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
}


export const shopifyStoresHead = [
    {name: 'name', title: 'Store Name', custom: false, type: 'notChange', headerCellWidth: '35%'},
    {name: 'secondaryName', title: 'Secondary Name', type: 'notChange', custom: false, headerCellWidth: '25%'},
    {name: 'createdAt', title: 'Added Date', type: 'notChange', custom: false, headerCellWidth: '20%'},
    {name: 'Status', title: 'Status', type: 'notChange', custom: false, headerCellWidth: '20%'},
];


export const shopifyStoresBody = () => {
    return [
        {rowText: (item) => <TextToolTip text={item?.name} content={item?.name}/>, width: '35%'},
        {rowText: (item) => <TextToolTip text={item?.secondaryName} content={item?.secondaryName}/>, width: '25%'},
        {rowText: (item) => <DateRow date={item?.createdAt}/>, width: '20%'},
        {
            button: (item, info, load) => (
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    {info?.status === shopifyStoresStatus.ACTIVE ?
                        <div
                            style={{
                                width: '119px',
                                color: '#0DA137',
                                fontFamily: "Open Sans",
                                fontSize: '14px',
                                fontStyle: 'normal',
                                fontWeight: '600',
                                lineHeight: '20px',

                                borderRadius: '4px',
                                background: '#E7F8EB',
                                padding: '4px 32px'
                            }}
                        >
                            Active
                        </div>

                        :
                        <div
                            style={{
                                width: '119px',
                                color: '#D72525',
                                fontFamily: "Open Sans",
                                fontSize: '14px',
                                fontStyle: 'normal',
                                fontWeight: '600',
                                lineHeight: '20px',

                                borderRadius: '4px',
                                background: '#FBF0F0',
                                padding: '4px 32px'
                            }}
                        >
                            Inactive
                        </div>
                    }

                </div>
            ),
            width: '20%'
        }
    ]
}

export const singleShopifyTabs = {
    'ORDERS': 'ORDERS',
    'PRICE_RULES': 'PRICE_RULES',
}


